export const SET = 'SET'
export const SET_ORDER = 'SET_ORDER'
export const SET_PRODUCT_ORDER = 'SET_PRODUCT_ORDER'
export const PUSH = 'PUSH'
export const SHOW = 'SHOW'
export const DESTROY = 'DESTROY'
export const UPDATE = 'UPDATE'
